const PushActionTypes = {
  SET_PUSH_PERMISSION: "SET_PUSH_PERMISSION",
  SET_PUSH_SUBSCRIPTION: "SET_PUSH_SUBSCRIPTION",
  SET_PUSH_LOADING: "SET_PUSH_LOADING",
  SET_PUSH_PROMPT_DISMISSED: "SET_PUSH_PROMPT_DISMISSED",
};

export default PushActionTypes;
